import React from "react";
import PropTypes from "prop-types";
import styles from "./CommonTextArea.module.css";

/**
 * Input reutilizável para textos maiores com diversas linhas
 */
function CommonTextArea({
  label,
  id,
  value,
  onChange,
  rows,
  required = false,
  disabled = false,
  ...props
}) {
  return (
    <>
      {label && (
        <>
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
          {required && <span style={{ color: "#f46a6a" }}> *</span>}
        </>
      )}
      <textarea
        className={styles.input}
        name={id}
        id={id}
        value={value}
        onChange={disabled ? null : onChange}
        rows={rows}
        disabled={disabled}
        {...props}
      ></textarea>
    </>
  );
}

CommonTextArea.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  rows: PropTypes.number.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CommonTextArea;
